import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'flagEmoji',
  standalone: true,
  pure: true
})
export class FlagEmojiPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(code: string | null | undefined): SafeHtml {
    if (!code || code.length < 2) return '';
    const lowerCode = code.substring(0, 2).toLowerCase();
    return this.sanitizer.bypassSecurityTrustHtml(
      `<img src="assets/images/flags/${lowerCode}.png" width="20" height="15" alt="${code}" style="vertical-align: middle; margin-right: 2px;" onerror="this.style.display='none'" />`
    );
  }
}
